/*
 * This Component is called by <ClassPages />, <ManageClassPatches />, <ManageClassPhotos /> and <MoreInfo />
 */
import React from 'react'
import Grid from '@material-ui/core/Grid'
import MySelect from "../Components/MySelect"
import PropTypes from 'prop-types'

const ClassDropdown = ({getSelectedClass, tpsClasses}) => {

   const selectedOption = (e) => {
      getSelectedClass(e.target.value)
   }
   
   return (
      <Grid data-testid='class-pages-dropdown'>
         <MySelect label="Select A Class" name="searchSelection" options={tpsClasses} selectedOption={selectedOption} />
      </Grid>
   )
}

ClassDropdown.propTypes = {
   getSelectedClass: PropTypes.func,
   tpsClasses: PropTypes.array
}

export default ClassDropdown
